var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"black--text white nfty-navbar-offset pa-sm-12"},[_c('v-row',[_c('v-col',{staticClass:"ml-4"},[_c('h2',[_vm._v("Your browser is not supported, please use Chrome")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }